<template>
  <div id="edit-info">
    <!-- title -->
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text">个人信息</p>
    </div>
    <form class="user-info">
      <div class="user-avatar" @click="goRouter('/croppa')">
        <img :src="avatar" alt="" class="user-img">
        <img src="@/assets/img/icon/camera.png" alt="" class="icon-camer">
      </div>
      <div class="input-area user-nick">
        <input type="text" placeholder="昵称" v-model="nickName">
      </div>
      <div class="input-area user-name">
        <input type="text" placeholder="真实姓名" v-model="realName">
      </div>
      <div class="input-area user-sex">
        <div class="sex-item" :class="{'is-active': crnSex == 'm'}" @click="selectSex('m')">
          <i class="iconfont iconnansvgzhuanhuan"></i>&nbsp;男
        </div>
        <div class="sex-item" :class="{'is-active': crnSex == 'f'}" @click="selectSex('f')">
          <i class="iconfont iconweibiaoti--copy"></i>&nbsp;女
        </div>
      </div>
      <div class="input-area user-birth">
        <!-- <input type="text" placeholder="出生日期"> -->
        <input
          readonly
          @click="showTimeSelect = true"
          type="text"
          class="item-detail"
          v-model="inputTime"
          placeholder="出生日期"
        >
      </div>
      <div class="input-area user-place">
        <!-- <input type="text" placeholder="所在地区"> -->
        <input
          type="text"
          readonly
          v-model="inputArea"
          @click="showAreaSelect = true"
          class="item-detail"
          placeholder="所在地区"
        >
      </div>
      <!-- <div class="input-area submit-btn">完成</div> -->
      <van-button
        class="input-area submit-btn"
        color="#37bd19"
        text="完成"
        size="large"
        @click.prevent="letSubmit"
        block
      ></van-button>
    </form>
    <!-- 时间弹出层 -->
    <van-popup v-model="showTimeSelect" position="bottom" :overlay="true">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        id="time-picker"
        :max-date="maxDate"
        :min-date="minDate"
        @cancel="showTimeSelect=false"
        @confirm="confirmTime"
        :visible-item-count="3"
        :item-height="66"
      />
    </van-popup>
    <!-- end -->
    <!-- 地址选择弹出层 -->
    <van-popup id="pop-area" v-model="showAreaSelect" position="bottom" :overlay="true">
      <van-area
        :area-list="areaList"
        value="440113"
        @cancel="showAreaSelect=false"
        @confirm="confirmArea"
      />
    </van-popup>
    <!-- end -->
  </div>
</template>
<script>
  import api from "@/api/index";
  import { currentHost } from "@/config";
  import areaList from "@/common/area.js";

  export default {
    data() {
      return {
        // avatar: require('@/assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png'),
        nickName: "",
        realName: "",
        crnSex: "男",
        inputTime: "",
        showTimeSelect: false, // 控制时间弹出组件
        minDate: new Date(1900, 10, 1),
        maxDate: new Date(),
        currentDate: new Date(1990, 9, 1),
        inputArea: "",
        areaList,
        province: "",
        city: "",
        area: "",
        showAreaSelect: false // 控制地址选择弹出组件
      };
    },
    created() {
      this.init();
    },
    computed: {
      avatar() {
        if (
          this.$store.state.userStore.userAvatar &&
          this.$store.state.userStore.userAvatar.trim()
        ) {
          return this.$store.getters.defaultUserAvatar;
        } else {
          if (
            sessionStorage.getItem("useravatar") &&
            sessionStorage.getItem("useravatar").trim()
          ) {
            return sessionStorage.getItem("useravatar");
          } else {
            return require("@/assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png");
          }
        }
      }
    },
    watch: {
      nickName: {
        handler: function(n, o) {
          if (n.length > 10) {
            this.nickName = n.slice(0, 11);
          }
        },
        immediate: true
      },
      realName: {
        handler: function(n, o) {
          if (n.length > 10) {
            this.realName = n.slice(0, 11);
          }
        },
        immediate: true
      }
    },
    methods: {
      init() {
        let userinfo = JSON.parse(localStorage.getItem("userInfo"));
        // this.avatar = `${currentHost+userinfo.avatar}`
        this.nickName = userinfo.nickname;
        this.realName = userinfo.truename;
        this.crnSex = userinfo.gender ? userinfo.gender : "m";
        this.currentDate = new Date(userinfo.birthday);
        this.inputTime = userinfo.birthday;
        this.inputArea = userinfo.province + userinfo.city + userinfo.area;
        this.province = userinfo.province;
        this.city = userinfo.city;
        this.area = userinfo.area;
      },
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else {
          this.$router.back(-1);
        }
      },
      goRouter(k) {
        this.$router.push(k);
      },
      confirmTime(d) {
        this.inputTime =
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
        this.showTimeSelect = false;
      },
      confirmArea(val) {
        this.inputArea = "";
        this.province = val[0].name;
        this.city = val[1].name;
        this.area = val[2].name;
        val.map(item => {
          this.inputArea += item.name + "";
        });
        this.showAreaSelect = false;
      },
      selectSex(k) {
        this.crnSex = k;
      },
      letSubmit() {
        if (
          !this.nickName.trim() ||
          !this.realName.trim() ||
          !this.inputTime ||
          !this.inputArea
        ) {
          this.$toast({
            message: "信息输入不全，请输入完整信息再提交~",
            duration: 1500
          });
        } else {
          let params = {
            nickname: this.nickName,
            truename: this.realName,
            gender: this.crnSex,
            birthday: this.inputTime,
            province: this.province,
            city: this.city,
            area: this.area
          };
          // 后续请求操作
          // api.editinfo
          this.$http.post(api.editinfo, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              console.log(params);
              this.$toast({
                duration: 1000,
                message: "操作成功~"
              });
              this.$router.go(-1);
            } else {
              this.$toast("出错了，请确认网络是否通畅及信息是否完整~");
            }
          });
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  #edit-info {
    width: 100vw;
    height: 100vh;
    background-color: #fffffd;
    & .top-title {
      width: 100%;
      padding: 27px 0;
      top: 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
    }
    .user-info {
      margin-top: 90px;
      text-align: center;
      font-size: 30px;
      margin-left: 89px;
      margin-right: 89px;
      input {
        width: 100%;
        height: 100%;
        text-align: center;
        border-style: none;
        padding: 0;
      }
      .user-avatar {
        position: relative;
        width: 179px;
        height: 179px;
        // overflow: hidden;
        margin: 150px auto 46px;
        background-color: #e1e2e6;
        border-radius: 50%;
        .user-img {
          border-radius: 50%;
          width: 179px;
          height: 179px;
        }
        .icon-camer {
          position: absolute;
          width: 38px;
          height: 38px;
          bottom: 8px;
          right: 5px;
        }
      }
      .input-area {
        height: 88px;
        line-height: 88px;
        border-radius: 44px;
        box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        margin-top: 60px;
      }
      .user-sex {
        display: flex;
        justify-content: space-between;
        box-shadow: none;
        overflow: unset;
        .sex-item {
          width: 275px;
          box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
          .iconfont {
            font-size: 27px;
          }
          &:first-of-type {
            border-radius: 44px 10px 10px 44px;
          }
          &:last-of-type {
            border-radius: 10px 44px 44px 10px;
          }
          &.is-active {
            box-shadow: 1px 8px 60px rgba(55, 189, 25, 0.2);
            color: #37bd19;
          }
        }
      }
      .submit-btn {
        color: #fff;
        box-shadow: 1px 8px 60px rgba(55, 189, 25, 0.2);
      }
    }

    /deep/ .van-picker__confirm,
    /deep/ .van-picker__cancel {
      font-size: 30px;
    }
    /deep/ .van-picker__toolbar {
      display: flex;
      align-items: center;
    }
    /deep/ .van-picker__toolbar {
      height: 100px !important;
    }
    /deep/ .van-picker-column {
      .van-picker-column__item {
        font-size: 32px;
      }
    }

    // 字体图标
    @font-face {
      font-family: "iconfont";
      src: url("//at.alicdn.com/t/font_1450975_hqrysdltkjk.eot?t=1571973016194"); /* IE9 */
      src: url("//at.alicdn.com/t/font_1450975_hqrysdltkjk.eot?t=1571973016194#iefix")
          format("embedded-opentype"),
        /* IE6-IE8 */
          url("data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAANEAAsAAAAABzgAAAL2AAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCDBgqCDIIWATYCJAMMCwgABCAFhG0HSxtxBhEVlNdkf4BMbuUHINGAY6BI2OBu4WU+YzmzdP15gARUQAIAAAAABM/Hmvk+LOCVHQBJZrSpbD2gTca3ikgC23MbADmAQJxb8fX7rvmdZSEXYQ7lFJDfJ93rUjpIX5r71ESAiKsS8gsz/39zK5bZ57kc31XPA5vfslzmGnjUy9I4oID2xqMjK5FAPI3wvHzhrTBfQ4CUDvRDxk+cPp8Yx9wkgGzfsmkNcSaB42I5RggrTjpym4BYr+gL4FbwffnNEAmUwDDfmr1xwnpGf4u+JXa6kuV2mtPT+QDxHBjQD3CQlZWBxVhU6IeR6jo3+iHEEXSqdCVQGKZwo388BQkxW3MAeqGo8C1yxBD4ltBAATAAQiABpgIXwGkzwwlCz/OydO7WY6nlUqwf+TXCv3278N27RW/eLHj9eqWtmx/K0pG3b9dVjZx+LWnvYs7b5Zmmywrytc6NI5vDu8Y/uffKlWbqdbtt2eoN12+NRtLd2JqstZpCu0+QIat3arLPkrJaquY8f/YNo5efP7/MaZVJsWNMPS9ddmDQcWTUG9eVuFtv3NAqpGBCups4cVn3Szz5weRHh8ukcfcn7h8d1WoAqtP2304HxNFfCCBw6R+1G36ZA/Dh/eUpXp12uruIrzAo8MWVHQfcUJtOc03hKP5loxfB88ggk8JUmJFWfB1uats5B0KcUYpQItrDiOlGOKcfAjKGISRmFFL6Mul8Rmv2YognQB8uEIQWPIBSUofRgpeEc74goB1/EdJCIGWhtL4xo4cAwvLCqAVf0P1BMDRZ2y3LsP2Jbh40p9UB7xM5hzQ0ZZ0vP3BCnmJP/natiAXLNMKd3sNhIEhMEY2UXiQdqspWMVQaGtVSXRi14Au6PwiGJuuNl2Xh809086C5gVKX/ETOYXpoyroD8TBMnSi3Qid/u1bEgmUa4U4+HKwCQapeFtFI6Qfk0qFiw2xXQ7m8aXy/E0CqzLm2UDFxdpOerjj/72c9OQ/sfjB0QZOEojCU/pQCAAA=")
          format("woff2"),
        url("//at.alicdn.com/t/font_1450975_hqrysdltkjk.woff?t=1571973016194")
          format("woff"),
        url("//at.alicdn.com/t/font_1450975_hqrysdltkjk.ttf?t=1571973016194")
          format("truetype"),
        /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
          url("//at.alicdn.com/t/font_1450975_hqrysdltkjk.svg?t=1571973016194#iconfont")
          format("svg"); /* iOS 4.1- */
    }

    .iconfont {
      font-family: "iconfont" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .iconnansvgzhuanhuan:before {
      content: "\e607";
    }

    .iconweibiaoti--copy:before {
      content: "\e609";
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdEditInfo.vue